'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-user-agent.js
// module id = nB5H
// module chunks = 19